<template>
<Layout @refresh-cart="$emit('refresh-cart', $event)" :show-cart="true" :show-header="false">
    <ShopNav />
    <div class="flex flex-col items-center justify-center md:w-5/6 mx-auto p-5">
        <transition name="fade" mode="out-in">
            <router-view @add-product-to-cart="$emit('add-product-to-cart', $event)" @refresh-cart="$emit('refresh-cart', $event)"></router-view>
        </transition>
    </div>
    <ShopFooter />
</Layout>
</template>

<script>
import Layout from '../components/Layout.vue';
import FootPrintsLoading from '../components/FootPrintsLoading';
import ProductDetail from '../components/ProductDetail';
import ShopNav from '../components/ShopNav.vue';
import ShopFooter from '../components/ShopFooter.vue';

const patternCount = 11;
let patternImages = {};
for (let i = 1; i < patternCount; i++) {
    patternImages[`p${i}`] = require(`../assets/showcase/${i}.png`);
}

export default {
    name: "ShopPage",
    props: {
        products: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            patternImages
        }
    },
    computed: {
        productsReversed() {
            return [...this.products].reverse()
        }
    },
    components: {
        ProductDetail,
        FootPrintsLoading,
        Layout,
        ShopNav,
        ShopFooter
    }
}
</script>

<style>
.scroll-item {
    max-width: 100px !important;
    flex-shrink: 1;
}

.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>
